import React from 'react'
import { get } from 'lodash'

import config from 'config'
import {
  AwardSummary,
  Dashboard
} from 'containers/pages'
import activity from './activity'
import aj from './aj'
import rp from './rp'
import { Restricted } from 'containers/misc'

const urlPrefix = `${config.publicPath}/dashboard/awards/:awardId`

export default [
  {
    path: `${urlPrefix}`,
    component: props => (
      <Restricted>
        <Dashboard
          params={get(props, 'match.params', {})}
          {...props}
        />
      </Restricted>
    ),
    routes: [
      ...activity,
      ...aj,
      ...rp,

      {
        path: `${urlPrefix}/award-summary`,
        component: props => (
          <AwardSummary
            params={get(props, 'match.params', {})}
            {...props}
          />
        )
      },
    ]
  }
]
